import { ClinicConfigTypes } from './ClinicConfig.types'

class ClinicConfigMapper {
  toDomain(domainData): ClinicConfigTypes {
    return {
      flagClinicUnifiedPV: domainData?.flagClinicaUnificadaPV,
      flagHabilitarNovaAgenda: domainData?.flagHabilitarNovaAgenda,
    }
  }
}

export default new ClinicConfigMapper()
